export const MAPCONTROL_NAME = "MapTools";